import { render, staticRenderFns } from "./Grades.vue?vue&type=template&id=cb990722"
import script from "./Grades.vue?vue&type=script&lang=js"
export * from "./Grades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports